import React, { useEffect, useState } from "react";
import axios from "../axios";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Loading from "../components/Loading";
import ProductPreview from "../components/ProductPreview";
import "../pages/styles/styles.css";

function CategoryPage() {
  const { category } = useParams();
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setLoading(true);
    axios
      .get(`/products/category/${category}`)
      .then(({ data }) => {
        setLoading(false);
        setProducts(data);
      })
      .catch((e) => {
        setLoading(false);
        console.log(`Error coming from ${e}`);
      });
  }, [category]);

  if (loading) {
    return <Loading />;
  }

  const productsSearch = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const renderProductPreviews = (
    filteredProducts,
    showBalance,
    showCountry
  ) => {
    return (
      <div className="forGrid">
        {filteredProducts.map((product) => (
          <ProductPreview
            key={product._id}
            {...product}
            showBalance={showBalance}
            showCountry={showCountry}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="category-page-container">
      <div
        className={`pt-3 ${category}-banner-container category-banner-container`}
      >
        <h1 className="text-center">
          {category.charAt(0).toUpperCase() + category.slice(1)} Log Product
        </h1>
      </div>
      <div className="filters-container d-flex justify-content-center pt-4 pb-4">
        <input
          type="search"
          placeholder="Search"
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      {productsSearch.length === 0 ? (
        <h1>No products to show</h1>
      ) : (
        <Container>
          {renderProductPreviews(
            productsSearch.filter(
              (product) =>
                product.category !== "Wallet stealer" &&
                product.category !== "WAX software"
            ),
            true,
            true
          )}

          {productsSearch.some(
            (product) => product.category === "Wallet stealer"
          ) && (
            <div>
              <h2>All Wallet Stealer</h2>
              {renderProductPreviews(
                productsSearch.filter(
                  (product) => product.category === "Wallet stealer"
                ),
                false,
                false
              )}
            </div>
          )}

          {productsSearch.some(
            (product) => product.category === "WAX software"
          ) && (
            <div>
              <h2>All WAX Software</h2>
              {renderProductPreviews(
                productsSearch.filter(
                  (product) => product.category === "WAX software"
                ),
                false,
                false
              )}
            </div>
          )}
        </Container>
      )}
    </div>
  );
}

export default CategoryPage;
